import { isAppx } from "./index";
var STORAGE_BIZ_TYPE = 'INTL_TRACKER';
function getKey(key) {
  return STORAGE_BIZ_TYPE + '-' + key;
}

// appx
function getStorage(key, defaultValue) {
  return new Promise(function (resolve) {
    my.getStorage({
      key: getKey(key),
      success: function success(_ref) {
        var data = _ref.data;
        try {
          var _ref2;
          var _data = JSON.parse(data);
          resolve((_ref2 = _data !== null && _data !== void 0 ? _data : defaultValue) !== null && _ref2 !== void 0 ? _ref2 : null);
        } catch (e) {
          resolve(defaultValue !== null && defaultValue !== void 0 ? defaultValue : null);
        }
      },
      fail: function fail() {
        resolve(defaultValue !== null && defaultValue !== void 0 ? defaultValue : null);
      }
    });
  });
}
function setStorage(key, data) {
  return new Promise(function (resolve) {
    if (data === null) {
      resolve({
        success: false
      });
    } else {
      var content = JSON.stringify(data);
      my.setStorage({
        key: getKey(key),
        data: content,
        success: function success() {
          resolve({
            success: true
          });
        },
        fail: function fail() {
          resolve({
            success: false
          });
        }
      });
    }
  });
}
function removeStorage(key) {
  return new Promise(function (resolve) {
    my.removeStorage({
      key: getKey(key),
      success: function success() {
        resolve({
          success: true
        });
      },
      fail: function fail() {
        resolve({
          success: false
        });
      }
    });
  });
}

// web
function getStorageToWeb(key, defaultValue) {
  return new Promise(function (resolve) {
    try {
      var res = localStorage.getItem(getKey(key));
      if (res === null) {
        resolve(defaultValue !== null && defaultValue !== void 0 ? defaultValue : null);
      } else {
        var _ref3, _JSON$parse;
        resolve((_ref3 = (_JSON$parse = JSON.parse(res)) !== null && _JSON$parse !== void 0 ? _JSON$parse : defaultValue) !== null && _ref3 !== void 0 ? _ref3 : null);
      }
    } catch (error) {
      resolve(defaultValue !== null && defaultValue !== void 0 ? defaultValue : null);
    }
  });
}
function setStorageToWeb(key, data) {
  return new Promise(function (resolve) {
    try {
      localStorage.setItem(getKey(key), JSON.stringify(data));
      resolve({
        success: true
      });
    } catch (error) {
      resolve({
        success: false
      });
    }
  });
}
function removeStorageToWeb(key) {
  return new Promise(function (resolve) {
    try {
      localStorage.removeItem(getKey(key));
      resolve({
        success: true
      });
    } catch (e) {
      resolve({
        success: false
      });
    }
  });
}
var storage;
if (isAppx) {
  storage = {
    getStorage: getStorage,
    setStorage: setStorage,
    removeStorage: removeStorage
  };
} else {
  storage = {
    getStorage: getStorageToWeb,
    setStorage: setStorageToWeb,
    removeStorage: removeStorageToWeb
  };
}
export { storage };